import { ThemeUICSSObject } from 'theme-ui';
/* IMPORT HERE */

export const speedui: ThemeUICSSObject = {
  /* PREPEND HERE */

  modal: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    p: 5,
    pointerEvents: 'none',
    position: 'fixed',
    right: 0,
    top: 0,

    '.modal__main': {
      pointerEvents: 'all',
    },

    '.speedui__selector': {
      maxHeight: 'calc(100vh - 100px)',
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative',
    },

    '.speedui__autocomplete': {
      position: 'sticky',
      top: 0,
    },

    '.speedui__autocomplete, .speedui__option': {
      p: 3,
      textAlign: 'left',
      width: '400px',
      scrollMarginTop: '50px',
    },

    '.speedui__option.selected': (theme) => ({
      backgroundColor: theme.palette.getColor(
        theme.palette.background.paper,
        'selected',
      ),
      color: theme.palette.getContrastText(
        theme.palette.getColor(theme.palette.background.paper, 'selected'),
      ),
    }),
  },
};
